import React from "react"; 
import { useTranslation } from "react-i18next";
import SignInForm from "./components/SignInForm";
import VerificationForm from "./components/VerificationForm";
import ForgotPasswordForm from "./components/ForgotPasswordForm";
import { useSignIn } from "./hooks/useSignIn";

const SignIn = () => {
  const { t } = useTranslation();
  const {
    step,
    loading,
    credentials,
    verificationCode,
    setStep,
    handleInputChange,
    setVerificationCode,
    handleLoginAttempt,
    handleVerifyCode,
    handleForgotPassword, 
  } = useSignIn();


   const composite = {
        login: <SignInForm
          t={t}
          credentials={credentials}
          handleInputChange={handleInputChange}
          handleLoginAttempt={handleLoginAttempt}
          loading={loading}
            setStep={setStep}   
        />, 
        verify: <VerificationForm
          t={t}
          verificationCode={verificationCode}
          setVerificationCode={setVerificationCode}
          handleVerifyCode={handleVerifyCode}
          handleLoginAttempt={handleLoginAttempt}
          loading={loading}
        />,
        forgot: <ForgotPasswordForm
          t={t}      
          setStep={setStep}
          handleInputChange={handleInputChange} 
          forgotData={credentials}
          handleForgotPassword={handleForgotPassword}      
          loading={loading}
        />
    
    };
const title ={login:t("Please verify your credentials to continue"),verify:t("enter_verification_code"),forgot:t("reset_password")}
  return (
    <div className="text-dark " tabIndex={0}>
      <div className=" mb-4">
        {/* <h3 className="fw-bold">{t("log_in")}</h3> */}
        <p className="text-muted small">       
           {title[step]}
        </p>
      </div>
      {composite[step]}
    </div>
  );
};

export default SignIn;
